<template>
  <div>
    <wc-data-box
      :title='$store.state.icons.dataBox.notes.title'
      :titleIcon='$store.state.icons.dataBox.notes.icon'
      :titleIconColor='$store.state.icons.dataBox.notes.iconColor'
      :showEdit='!expense.reconciliation && !expense.is_posted'
      @edit='edit'
    >
      <v-card-text v-if='expense.notes'>{{ expense.notes }}</v-card-text>
      <v-card-text v-else class='grey--text'>No notes...</v-card-text>
    </wc-data-box>

    <wc-dialog
      :title='$store.state.icons.dataBox.notes.title'
      :icon='$store.state.icons.dataBox.notes.icon'
      :iconColor='$store.state.icons.dataBox.notes.iconColor'
      :showDialog='showDialog'
      @cancel='showDialog = false'
      @save='save'
    >
      <v-textarea outlined
        v-model='expenseCopy.notes'
      ></v-textarea>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'expense-notes',
  props: {
    expense: {
      required: true
    }
  },
  data: () => ({
    expenseCopy: {},
    showDialog: false
  }),
  methods: {
    resetCopy () {
      this.expenseCopy = _.cloneDeep(this.expense)
    },
    edit () {
      this.resetCopy()
      this.showDialog = true
    },
    save () {
      this.$emit('update', this.expenseCopy)
      this.showDialog = false
    }
  }
}
</script>
